var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"href":"https://coreui.io","target":"_blank"}},[_vm._v("MetaV Kids")]),_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(new Date().getFullYear()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }